import { useMutation, useQuery } from "@tanstack/react-query";
import { getCarIconsFn, postCarIconsFn } from "../../transactions/notificationsGuide/notificationsGuide";
import { toast } from "../../components/ui/Toast/useToast";


export const useGetCarIcons = (serviceFlowId) => {
    return useQuery({
        queryKey: [],
        queryFn: getCarIconsFn,
        refetchOnWindowFocus: false
    })
};


export const useGetCarIconInfo = () => {
  return useMutation({
    mutationFn: (carIcons) => postCarIconsFn(carIcons),
    onError: () => {
        toast({
            variant: "destructive",
            description: "Παρουσιάστηκε κάποιο πρόβλημα",
        });
    }
  });
};